<p-progressBar
    [value]="normalizedValue"
    [showValue]="false"
    [styleClass]="trackClass"
    [style]="{ height: height, width: '100%' }">
</p-progressBar>
<span *ngIf="showLabel" class="itp-progress-bar__label">
    {{ normalizedValue | number:(decimalLabel ? '1.1-1' : '1.0-0') }}%
</span>
